import Api from "@/utils/axios";
import newApi from "@/utils/axios-images";
import {
  Auth,
  deleteToken,
  removeAuth,
  removeToken,
  
  setLogged,
  setToken
} from "@/utils/auth";

export default {
  namespaced: true,
  state: {
    userToken: null,
    authUser: {},
    userProfileData: {},
    userNotifications:[]
  },
  getters: {
    getUserToken(state){
      return state.userToken
    },
    getAuthUser(state){
      return state.authUser
    },
    getUserProfileData(state){
      return state.userProfileData
    },
    getUserNotifications(state){
      return state.userNotifications
    },
  },
  mutations: {
    SET_TOKEN(state, token){
      state.userToken = token
    },
    SET_AUTH(state, user){
      state.authUser = user
    },
    SET_PROFILE_DATA(state, profileData){
      state.userProfileData = profileData
    },
    SET_NOTIFICATIONS_DATA(state, notes){
      state.userNotifications = notes
    },
  },
  actions: {
    // Handler Register User
    async handlerRegister({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("register", payload).then((response)=>{
          if (response.status == 200) {
            setLogged("1");
            setToken(response.data.token);
            Auth(JSON.stringify(response.data));
            commit("SET_TOKEN", response.data.token);
            commit("SET_AUTH", JSON.stringify(response.data));
          }
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Login User
    async handlerLogin({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("login", payload).then((response)=>{
          if (response.status == 200) {
            setLogged("1");
            setToken(response.data.token);
            Auth(JSON.stringify(response.data));
            commit("SET_TOKEN", response.data.token);
            commit("SET_AUTH", JSON.stringify(response.data));
          }
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Logout
    async handlerLogout({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("logout", payload).then((response)=>{
            commit("SET_TOKEN", "");
            commit("SET_AUTH", []);
            removeToken();
            deleteToken();
            removeAuth();

          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Forget Password
    async handlerForgetPassword({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post(`reset-password`, payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Check Code
    async handlerCheckCode({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("check-code", payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Confirm Reset Password
    async handlerConfirmResetPassword({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("confirm-reset", payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler User Profile
    async handlerUserProfile({commit}) {
      return await new Promise((resolve, reject) => {
        Api.get("profile").then((response)=>{
          commit("SET_PROFILE_DATA", response.data.profile);
          
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Update User Profile
    async handlerUpdateUserProfile({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("update-profile", payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Update User Profile Image
    async handlerUpdateUserProfileImage({commit}, payload) {
      return await new Promise((resolve, reject) => {
        newApi.post("update-image", payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Get Notifications // 
    async handlerNotificationsData({commit}) {
      return await new Promise((resolve, reject) => {
        Api.get("notifications").then((response)=>{
          let notifications = response.data
          // console.log(response.data);
          // let allNotifications = [];

          let allNotificationsWithDate = [];
          notifications.forEach(element => {
            allNotificationsWithDate.push({
              day: element.day[0].day,
              allNotifications: element.day
            })
          });
       
          commit("SET_NOTIFICATIONS_DATA", allNotificationsWithDate)
          
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
  }
};
